<template>
  <Navbar :title="title" :class="{'show': showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">Cerrar</div>
    </template>
    <template v-slot:content>
      <div class="form-group">
        <label for="adminName">Nombre</label>
        <input v-model.trim="form.name" class="input" type="text" id="adminName" maxlength="80">
        <span v-if="errors.name" class="error">{{ errors.name }}</span>
      </div>
      <div class="form-group">
        <label for="adminLastName">Apellido</label>
        <input v-model.trim="form.lastName" class="input" type="text" id="adminLastName" maxlength="80">
        <span v-if="errors.lastName" class="error">{{ errors.lastName }}</span>
      </div>
      <div class="form-group">
        <label for="adminDocument">N° documento</label>
        <input v-model.trim="form.document" class="input" type="text" id="adminDocument" maxlength="20">
        <span v-if="errors.document" class="error">{{ errors.document }}</span>
      </div>
      <div class="form-group">
        <label for="adminEmail">Email</label>
        <input v-model.trim="form.email" class="input" type="email" id="adminEmail" maxlength="120">
        <span v-if="errors.email" class="error">{{ errors.email }}</span>
      </div>
      <div class="form-group">
        <label for="adminPassword">Contraseña</label>
        <input v-model="form.password" class="input" type="password" id="adminPassword" maxlength="64" autocomplete="new-password">
        <span class="form-hint">Solo para cuentas nuevas. Si la persona ya tiene cuenta en Inqi, déjala vacía y solo se le otorgará el acceso admin.</span>
        <span v-if="errors.password" class="error">{{ errors.password }}</span>
      </div>
    </template>
    <template v-slot:footer>
      <button :disabled="progress" :class="{'is-loading': progress}" @click="submit" class="btn">
        <span v-if="!progress">Agregar administrador</span>
      </button>
    </template>
  </Navbar>
</template>

<script>
import Navbar from '@/components/Navbar'
import { functions } from '@/firebase/firebaseConfig'
import * as yup from 'yup'

yup.setLocale({
  mixed: { required: 'Este campo es obligatorio' },
  string: { email: 'Email inválido', min: 'Muy corto', max: 'Demasiado largo' }
})

const schema = yup.object().shape({
  name: yup.string().max(80).required().label('Nombre'),
  lastName: yup.string().max(80).required().label('Apellido'),
  document: yup.string().max(20).required().label('Documento'),
  email: yup.string().email().max(120).required().label('Email'),
  // Opcional: si se ingresa, mínimo 6. Vacía = otorgar a cuenta existente.
  password: yup.string()
    .transform(v => (v === '' ? undefined : v))
    .min(6, 'Mínimo 6 caracteres')
    .max(64)
    .notRequired()
    .label('Contraseña')
})

export default {
  name: 'AddAdmin',
  components: { Navbar },
  props: {
    showNavbar: { type: Boolean, default: false },
    title: { type: String }
  },
  emits: ['added', 'close'],
  data () {
    return {
      form: { name: '', lastName: '', document: '', email: '', password: '' },
      errors: {},
      progress: false
    }
  },
  watch: {
    showNavbar (value) {
      if (value) {
        this.form = { name: '', lastName: '', document: '', email: '', password: '' }
        this.errors = {}
      }
    }
  },
  methods: {
    async submit () {
      try {
        this.progress = true
        this.errors = {}
        await schema.validate({ ...this.form }, { abortEarly: false })

        const callable = functions.httpsCallable('admins-createAdmin')
        const result = await callable({
          email: this.form.email.toLowerCase(),
          password: this.form.password || '',
          name: this.form.name,
          lastName: this.form.lastName,
          document: this.form.document
        })

        this.$emit('added', {
          uid: result.data.uid,
          email: result.data.email,
          name: result.data.name,
          lastName: result.data.lastName,
          document: result.data.document,
          addedAt: new Date()
        })
        this.$toast.success(result.data.created ? 'Administrador creado' : 'Acceso admin otorgado (la cuenta ya existía)')
        this.form = { name: '', lastName: '', document: '', email: '', password: '' }
      } catch (e) {
        if (e.inner) {
          e.inner.forEach(err => { if (err.path) this.errors[err.path] = err.message })
        } else if (e.code === 'functions/already-exists') {
          this.errors.email = 'Ya existe una cuenta con ese email'
        } else if (e.code === 'functions/invalid-argument') {
          this.errors.password = e.message || 'Revisa los datos'
        } else if (e.code === 'functions/permission-denied') {
          this.$toast.error('No tienes permisos de administrador')
        } else {
          this.$toast.error('Error al agregar administrador')
        }
      } finally {
        this.progress = false
      }
    }
  }
}
</script>
